export const disciplineImage = (name: string, width: 240 | 480) => {
  if (name.toLowerCase().trim().startsWith("http://") || name.toLowerCase().trim().startsWith("https://")) {
    return name;
  }
  const parts = name.split(".");
  const noExtension = parts.length === 1 ? name : parts.slice(0, -1).join(".");
  return `/disciplines/w${width}px/${noExtension}.jpg`;
};
